import { render } from "./2PenyiapanKawasandanPembangunanTransmigrasi.vue?vue&type=template&id=ed430c9a&scoped=true"
import script from "./2PenyiapanKawasandanPembangunanTransmigrasi.vue?vue&type=script&lang=js"
export * from "./2PenyiapanKawasandanPembangunanTransmigrasi.vue?vue&type=script&lang=js"

import "./2PenyiapanKawasandanPembangunanTransmigrasi.vue?vue&type=style&index=0&id=ed430c9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed430c9a"]])

export default __exports__